/**
 * Calculate total installation time for a project
 * @param {Object} project - The project object with sections, jumps, and parameters
 * @returns {number} Total installation hours
 */
export function calculateInstallTime(project) {
  const { sections = [], jumps = [], parameters = {} } = project;
  
  const totalLightingFeet = sections.reduce((sum, s) => sum + (s.length_feet || 0), 0);
  const spacingInches = parameters.light_spacing_inches || 12;
  const totalPucks = Math.ceil((totalLightingFeet * 12) / spacingInches);
  
  // Labor time calculation (in hours) - matches MaterialsList detailed breakdown
  const setupTime = 1.0; // Setup & Planning
  const sectionInstallTime = sections.length * 0.5; // Section Installation (30 min per section)
  const puckInstallTime = (totalPucks / 10) * 0.25; // Puck mounting (15 min per 10 pucks)
  const jumpTime = jumps.length * 0.5; // Jump wire runs (30 min per jump)
  
  const totalLaborHours = setupTime + sectionInstallTime + puckInstallTime + jumpTime;
  
  return Math.ceil(totalLaborHours * 2) / 2; // Round up to nearest 0.5 hour
}
